var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EIcon',{staticClass:"personal-counter-indicator__icon",class:{ 'personal-counter-indicator__icon--delayed': _vm.withDelay },attrs:{"icon":"highlight-star","size":"s"}})}
var staticRenderFns = []

export { render, staticRenderFns }